import find from "lodash/fp/find";
import isNil from "lodash/fp/isNil";
import isEmpty from "lodash/fp/isEmpty";
import moment from "moment";
import constants from "../../core/constants";
import { toObject } from "../../core/utils";

class BackupPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists.all;
  }

  justify(data) {
    const findByStatusName = (item) => item.name === data.status;
    const findByStationStatusName = (item) =>
      item.name === data.backup_station_status;

    data.start_date = data.start_date
      ? moment(data.start_date).format(constants.dateTimeFormat)
      : null;
    data.end_date = data.end_date
      ? moment(data.end_date).format(constants.dateTimeFormat)
      : null;

    data.last_sent_location = data.last_sent_location
      ? moment(data.last_sent_location).format(constants.dateTimeFormat)
      : null;
    data.status = find(findByStatusName)(this.Lists.backupStatus);
    data.backup_station_status = data.backup_station_status
      ? find(findByStationStatusName)(this.Lists.backupStationStatus)
      : "";

    data.captain_location_marker = data.captain_location
      ? [data.captain_location.lat, data.captain_location.lng]
      : [];

    // Flatten data.station_history.actions array
    data.station_history_flat = isEmpty(data.station_history)
      ? []
      : data.station_history.reduce((acc, curr) => {
          const actions = curr.actions.map((action) => {
            const time = moment(action.time).format(constants.dateTimeFormat);
            return {
              ...(curr.station_id ? curr.station_id : {}),
              ...action,
              time,
            };
          });
          return acc.concat(actions);
        }, []);

    // Sort data.station_history_flat by time
    data.station_history_flat = data.station_history_flat.sort((a, b) => {
      return new Date(b.time) - new Date(a.time);
    });

    if (!isNil(data.ride_category)) {
      data.ride_category.label = `${data.ride_category.ride_type} ${data.ride_category.service_type}`;
    }

    return toObject(data);
  }
}

export default BackupPageTransform;



// WEBPACK FOOTER //
// ./src/pages/backup/backup.transforms.js